module.exports = __webpack_public_path__ + "img/map4.443aa0e2.png";